import React, { useState, useEffect } from 'react';

const MediaModal = ({ show, onClose, onSave, loading }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: 'Live',
    url_video: '',
    description: '',
    thumbnail: ''
  });

  // Nettoyer le formulaire à la fermeture
  useEffect(() => {
    if (!show) {
      setFormData({ title: '', category: 'Live', url_video: '', description: '', thumbnail: '' });
    }
  }, [show]);

  // Extraction automatique de la miniature
  useEffect(() => {
    const url = formData.url_video;
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      if (match && match[2].length === 11) {
        setFormData(prev => ({ 
          ...prev, 
          thumbnail: `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg` 
        }));
      }
    } else {
      setFormData(prev => ({ ...prev, thumbnail: '' }));
    }
  }, [formData.url_video]);

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      ...formData,
      url: formData.url_video,
      source_type: formData.url_video.includes('youtube') ? 'youtube' : 'link'
    };
    onSave(finalData);
  };

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)', zIndex: 1050 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content bg-dark text-white border-0 shadow-lg rounded-5 overflow-hidden">
          
          <div className="bg-info" style={{ height: '6px' }}></div>

          <div className="modal-header border-secondary border-opacity-25 p-4">
            <h5 className="fw-black text-uppercase m-0 italic">
              <i className="bi bi-cloud-arrow-up-fill text-info me-2"></i>
              Nouveau Média Studio
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body p-4">
              <div className="row">
                {/* Colonne Gauche : Aperçu visuel */}
                <div className="col-md-5 mb-3">
                  <div className="mb-3 bg-black rounded-4 overflow-hidden border border-secondary border-opacity-25 d-flex align-items-center justify-content-center" style={{ height: '200px', position: 'relative' }}>
                    {formData.thumbnail ? (
                      <>
                        <img 
                          src={formData.thumbnail} 
                          alt="Preview" 
                          className="w-100 h-100 object-fit-cover" 
                          style={{ display: 'block' }} 
                        />
                        {/* MISE À JOUR : Icône Play épurée sans le rond bleu */}
                        <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style={{ background: 'rgba(0,0,0,0.3)' }}>
                            <i className="bi bi-play-fill text-white display-3 opacity-75"></i>
                        </div>
                      </>
                    ) : (
                      <div className="text-center text-secondary">
                        <i className="bi bi-camera-video display-6"></i>
                        <p className="small fw-bold text-uppercase mt-2 mb-0" style={{ fontSize: '10px' }}>En attente de lien YouTube...</p>
                      </div>
                    )}
                  </div>

                  <label className="text-secondary small fw-black text-uppercase mb-2" style={{ fontSize: '10px' }}>Description / Notes</label>
                  <textarea 
                    className="form-control bg-black border-secondary border-opacity-50 text-white p-3 rounded-3 shadow-none"
                    rows="3"
                    placeholder="Détails sur l'émission..."
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                  ></textarea>
                </div>

                {/* Colonne Droite : Infos */}
                <div className="col-md-7">
                  <div className="mb-3">
                    <label className="text-secondary small fw-black text-uppercase mb-2" style={{ fontSize: '10px' }}>Titre de la vidéo</label>
                    <input 
                      type="text" 
                      className="form-control bg-black border-secondary border-opacity-50 text-white p-3 rounded-3 shadow-none"
                      placeholder="Ex: Le Morning 974 avec l'invité..."
                      value={formData.title}
                      onChange={(e) => setFormData({...formData, title: e.target.value})}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="text-secondary small fw-black text-uppercase mb-2" style={{ fontSize: '10px' }}>Catégorie</label>
                    <select 
                      className="form-select bg-black border-secondary border-opacity-50 text-white p-3 rounded-3 shadow-none"
                      value={formData.category}
                      onChange={(e) => setFormData({...formData, category: e.target.value})}
                    >
                      <option value="Live">🔴 Live Replay</option>
                      <option value="Interview">🎤 Interview</option>
                      <option value="Musique">🎶 Clip Musique</option>
                      <option value="Actu">📰 Actualité</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="text-secondary small fw-black text-uppercase mb-2" style={{ fontSize: '10px' }}>Collez le lien YouTube ici</label>
                    <div className="input-group">
                      <span className="input-group-text bg-black border-secondary border-opacity-50 text-info">
                        <i className="bi bi-youtube"></i>
                      </span>
                      <input 
                        type="url" 
                        className="form-control bg-black border-secondary border-opacity-50 text-white p-3 rounded-end-3 shadow-none"
                        placeholder="https://www.youtube.com/watch?v=..."
                        value={formData.url_video}
                        onChange={(e) => setFormData({...formData, url_video: e.target.value})}
                        required
                      />
                    </div>
                  </div>

                  <div className="p-3 rounded-4 bg-info bg-opacity-10 border border-info border-opacity-25 mt-4">
                    <div className="d-flex align-items-center text-info mb-1">
                      <i className="bi bi-info-circle-fill me-2"></i>
                      <span className="small fw-black text-uppercase" style={{ fontSize: '9px' }}>Info Régie</span>
                    </div>
                    <p className="mb-0 text-white-50" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                      L'aperçu s'affiche automatiquement dès que le lien est valide. Cliquez sur publier pour envoyer en galerie.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer border-0 p-4 pt-0">
              <button type="button" className="btn btn-link text-secondary text-decoration-none fw-bold" onClick={onClose} disabled={loading}>
                Annuler
              </button>
              <button type="submit" className="btn btn-info rounded-pill px-5 py-2 fw-black text-uppercase shadow-lg" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Publication...
                  </>
                ) : (
                  'Publier sur le site'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MediaModal;